import React, { Dispatch, SetStateAction } from "react";
import "./GameTabs.scss";
import { GameState } from "../GamePlayer";
import { TabFolder } from "./TabFolder/TabFolder";

interface IProps {
    gameState: GameState
    setGameState: Dispatch<SetStateAction<GameState>>
}

export function GameTabs({
    gameState,
    setGameState
                          }: IProps) {
    const visible = ['intro', 'tutorial', 'win', 'game-over'].includes(gameState);
    const activeTab: {[key: string]: 'info' | 'chat' | 'result'} = {
        intro: 'info',
        tutorial: 'chat',
        win: 'result',
        'game-over': 'result',

    }

    return (
        <div className={`game-tabs-wrapper ${visible ? 'visible' : ''}`}>
            <svg xmlns="http://www.w3.org/2000/svg" width="910" height="1530" viewBox="0 0 910 1530">
                <path id="Map" d="M451.213,8.787,368.787,91.214A30,30,0,0,1,347.573,100H30A30,30,0,0,0,0,130V1490a30,30,0,0,0,30,30H870a30,30,0,0,0,30-30V30A30,30,0,0,0,870,0H472.426a30,30,0,0,0-21.213,8.787" transform="translate(5 5)" fill="#cff0ff" stroke="#000" strokeWidth="10"/>
                {/* eslint-disable-next-line react/jsx-no-comment-textnodes */}
                <text id="_CASE_2938-002" data-name="///////////////// CASE 2938-002" transform="translate(498 100)" fontSize="24" fontFamily="QuietSans-SemiBold, quiet-sans" fontWeight="600" letterSpacing="0.05em"><tspan x="0" y="0">///////////////// CASE 2938-002</tspan></text>
            </svg>
            <div className="folder-contents-wrapper">
                <h1>VIRUS ALERT</h1>
                <div className="folder-contents-tab-container">
                    <TabFolder activeTab={activeTab[gameState ?? 'intro']} />
                </div>
            </div>
        </div>
    )
}
